import type { Translation } from '../../types';
import type { domainPage as en } from '../en/domainPage';

export const domainPage: Translation<typeof en> = {
  header: {
    copy: 'Sao chép',
    copied: 'Đã sao chép',
    picker: 'Tên miền đang xem',
    export: 'Xuất thông tin',
  },
  ribbon: {
    service: 'Dịch vụ',
    registry: 'Registry',
    dossier: 'Hồ sơ',
    billing: 'Thanh toán',
    sync: 'Đồng bộ',
    dnssec: 'DNSSEC',
    loading: 'Đang tải…',
    stopped: 'Đăng ký bị dừng',
    unresolved_one: '{{count}} lệnh chưa rõ kết quả',
    unresolved_other: '{{count}} lệnh chưa rõ kết quả',
    registryOk: 'Bình thường',
    registryNone: 'Chưa đọc',
    inSync: 'Khớp',
    drift_one: '{{count}} chênh lệch',
    drift_other: '{{count}} chênh lệch',
    notCompared: 'Chưa đối chiếu',
    unavailable: 'Không xem được',
    dnssecOn: 'Đã cấu hình',
    dnssecOff: 'Chưa bật',
  },
  tabs: {
    label: 'Các phần của tên miền',
    mobile: 'Phần đang xem',
    overview: 'Tổng quan',
    subject: 'Chủ thể & liên hệ',
    dossier: 'Hồ sơ & định danh',
    dns: 'DNS & máy chủ tên',
    dnssec: 'DNSSEC',
    addons: 'Add-on & phí',
    finance: 'Tài chính',
    lifecycle: 'Vòng đời',
    transfer: 'Chuyển & bảo mật',
    registry: 'Registry',
    compliance: 'Tuân thủ & đồng bộ',
    history: 'Lịch sử & ghi chú',
  },
  context: {
    title: 'Quản lý tên miền',
    noSubject: 'Chưa có chủ thể',
    customer: 'Tài khoản',
    dossier: 'Hồ sơ hiện tại',
    policy: 'Quy định',
    registered: 'Ngày đăng ký',
    openSubject: 'Chi tiết chủ thể',
    back: 'Về danh sách',
  },
  actions: {
    title: 'Thao tác tên miền',
    statusTitle: 'Khoá & tự gia hạn',
    hold: 'Khoá tên miền',
    updateLock: 'Khoá cập nhật',
    subtitle: 'Mỗi thay đổi cần lý do và được ghi nhật ký.',
    autoRenew: 'Tự động gia hạn',
    autoRenewOn: 'Bật · {{years}} năm',
    transferLock: 'Khoá chuyển',
    on: 'Bật',
    off: 'Tắt',
    redemption: 'Tên miền đang {{state}}: không gia hạn theo cách thông thường.',
    unresolved: 'Có lệnh registry chưa rõ kết quả: cần đối soát trước.',
    notActive: 'Không gia hạn được khi tên miền đang {{state}}.',
  },
  checks: {
    title: 'Điều kiện gia hạn',
    subtitle: 'Những gì trang này thấy được; khi gia hạn hệ thống kiểm tra lại.',
    dossier: 'Hồ sơ hoàn tất',
    registry: 'Mọi lệnh registry đã có kết quả',
    state: 'Trạng thái cho phép gia hạn',
    locks: 'Không có khoá pháp lý',
    balance: 'Số dư: kiểm tra khi thực hiện',
    met: 'Đạt',
    notMet: 'Chưa đạt',
    later: 'Kiểm tra sau',
  },
  subject: {
    title: 'Chủ thể sở hữu tên miền',
    titleHint: 'Chủ thể pháp lý, tách biệt với tài khoản thanh toán.',
    failed: 'Không tải được chủ thể',
    editSubject: 'Sửa chủ thể',
    pinned: 'Phiên bản {{n}} trong hồ sơ',
    pinnedOld: 'Hồ sơ giữ phiên bản {{pinned}} (hiện là {{current}})',
    notVerified: 'Chưa xác minh',
    noProfile: 'Không xem được thông tin của chủ thể.',
    fullName: 'Họ và tên',
    legalName: 'Tên pháp lý',
    tradeName: 'Tên giao dịch',
    position: 'Chức vụ',
    birthDate: 'Ngày sinh',
    birthMissing: 'Chưa có',
    gender: 'Giới tính',
    idNumber: 'Số định danh',
    idAndTax: 'Số CCCD (cũng là mã số thuế)',
    taxCode: 'Mã số thuế / mã số doanh nghiệp',
    householdTax: 'Mã số thuế (CCCD của chủ hộ)',
    founded: 'Ngày thành lập',
    nationality: 'Quốc tịch',
    country: 'Quốc gia',
    phone: 'Điện thoại',
    email: 'E-mail',
    fax: 'Fax',
    address: 'Địa chỉ',
    headOffice: 'Trụ sở chính',
    representative: 'Người đại diện theo pháp luật',
    owner: 'Chủ hộ kinh doanh',
    representativeHint: 'Một chủ thể cá nhân riêng, đủ thông tin như một cá nhân.',
    representativeFailed: 'Không tải được người đại diện',
    openRepresentative: 'Mở',
    noRepresentative: 'Chưa có người đại diện theo pháp luật',
    noRepresentativeBody: 'Gắn một cá nhân làm người đại diện trước khi lập hồ sơ hoặc cập nhật registry.',
    since: 'Đại diện từ {{date}}',
  },
  contacts: {
    atRegistry: 'So với registry',
    title: 'Các đầu mối liên hệ của tên miền',
    hint: 'Chủ thể, quản trị, kỹ thuật và thanh toán thuộc riêng tên miền này: sao chép từ chủ thể khi đăng ký; sửa liên hệ nào chỉ ảnh hưởng tên miền này.',
    differs: 'khác chủ thể hiện tại',
    origins: { CLONED: 'Sao chép khi đăng ký', SYNCED: 'Đồng bộ từ chủ thể', EDITED: 'Sửa riêng cho tên miền' },
    syncing: 'Đang cập nhật tại registry',
    drift_one: 'Lệch {{count}} trường',
    drift_other: 'Lệch {{count}} trường',
    matches: 'Khớp chủ thể',
    edit: 'Đổi',
    registryId: 'Mã tại registry',
    noHandle: 'Registry này không dùng mã liên hệ',
    organization: 'Tổ chức',
    name: 'Tên',
    position: 'Chức vụ',
    email: 'E-mail',
    phone: 'Điện thoại',
    fax: 'Fax',
    address: 'Địa chỉ',
    ids: 'Giấy tờ định danh',
    nationality: 'Quốc tịch',
    noDetails: 'Vai trò của bạn không xem được thông tin liên hệ.',
    fromSubject: 'Theo',
    version: 'phiên bản {{n}}',
    notCurrent: 'không phải phiên bản hiện tại',
    since: 'từ {{date}}',
    copiedAt: 'sao chép lần đầu {{date}}',
    source: 'Nguồn',
    showPast_one: 'Liên hệ trước đây ({{count}})',
    showPast_other: 'Liên hệ trước đây ({{count}})',
    hidePast: 'Ẩn liên hệ trước đây',
    driftTitle_one: '{{count}} liên hệ đang khác chủ thể',
    driftTitle_other: '{{count}} liên hệ đang khác chủ thể',
    driftBody: 'Các trường tô màu đã đổi ở chủ thể sau khi sao chép. Tên miền không tự thay đổi cho đến khi nhân viên chọn đồng bộ.',
    syncFromSubject: 'Đồng bộ từ chủ thể',
    syncFrom: 'Đồng bộ từ {{name}}',
    syncTitle: 'Đồng bộ liên hệ từ chủ thể · {{domain}}',
    syncDescription_one: 'Liên hệ {{roles}} đang lệch lấy thông tin hiện tại của {{name}}, chỉ cho tên miền này.',
    syncDescription_other: '{{count}} liên hệ đang lệch ({{roles}}) lấy thông tin hiện tại của {{name}}, chỉ cho tên miền này.',
    theirSubject: 'chủ thể của liên hệ',
    syncResult: {
      STARTED: 'Đã bắt đầu: đang cập nhật tại registry.',
      REGISTRANT_CHANGE: 'Chính chủ thể đã đổi: đã mở yêu cầu đổi chủ thể.',
      UP_TO_DATE: 'Đã khớp với chủ thể.',
      SKIPPED: 'Không đồng bộ (xem lý do ở trang chủ thể).',
    },
  },
  scope: {
    title: 'Tài khoản & phạm vi ảnh hưởng',
    hint: 'Thay đổi ở đây không ghi đè danh tính đã xác minh hay liên hệ của tên miền khác.',
    account: 'Tài khoản thanh toán',
    domain: 'Tên miền đang xem',
    change: 'Phạm vi thay đổi',
    changeValue: 'Chỉ tên miền này',
    others: 'Tên miền khác cùng chủ thể',
    none: 'Không có',
    ownershipTitle: 'Đổi chủ thể là một nghiệp vụ riêng',
    ownershipBody: 'Không đổi chủ sở hữu bằng cách sửa tên, e-mail hay tài khoản thanh toán.',
    ownershipLink: 'Mở Chuyển & bảo mật',
  },
  dossierPanel: {
    title: 'Hồ sơ',
    version: 'Phiên bản {{n}}',
    history: 'Lịch sử',
    open: 'Mở trang hồ sơ',
    next: {
      title: 'Xử lý hồ sơ',
      approve: 'Duyệt hồ sơ',
      approvePaper: 'Duyệt bản khai giấy',
      review: 'Đối chiếu giấy tờ và kết quả kiểm tra bên dưới, rồi duyệt hoặc từ chối ngay tại đây. Quyết định áp dụng cho hồ sơ, không phải riêng từng tệp.',
      individual: 'Cá nhân cần eKYC. Nhân viên có thể tải giấy tờ vào hồ sơ tại đây; duyệt bản giấy không thay cho eKYC. Sau khi khách xác minh, hệ thống chuyển bản khai sang bước NĐK ký.',
      paper: 'Tải mẫu bản khai, lấy bản đã ký và đóng dấu rồi chọn “Tải hồ sơ thủ công”. Hệ thống đối chiếu bản giấy; khi kiểm tra xong, nút “Duyệt bản khai giấy” xuất hiện ngay tại đây.',
      checking: 'Đang đối chiếu bản khai đã nộp. Sau khi kiểm tra xong, nhân viên duyệt bản giấy ngay tại đây.',
      sign: 'Chủ thể đã xác minh. Kiểm tra tệp bên dưới và gửi NĐK ký bản khai để hoàn tất hồ sơ.',
      complete: 'Hồ sơ đã hoàn tất. Kết quả gửi VNNIC được hiển thị bên dưới.',
      remindEkyc: 'Nhắc khách làm eKYC',
    },
    fileState: { GENERATED: 'Bản mẫu', STORED: 'Đã lưu', AWAITING_IDENTITY: 'Chờ định danh', AWAITING_CHECK: 'Đang kiểm tra' },
    upload: {
      title: 'Tải lên hồ sơ',
      kind: 'Loại hồ sơ',
      file: 'Tệp',
      submit: 'Tải lên',
      manual: 'Tải hồ sơ thủ công',
      template: 'Tải mẫu',
      templateHint: 'Tải bản khai tên miền đã điền sẵn thông tin chủ thể',
      noTemplate: 'Tên miền chưa có bản khai để tải',
      ekyc: 'eKYC',
      identity: 'Xem thông tin CCCD',
      identityOrg: 'Xem thông tin chủ thể',
      requiredOption: '{{name}} — bắt buộc',
      noSlots: 'Hồ sơ này không có loại tệp nào nhân viên tải lên được',
      pickFile: 'Chọn loại hồ sơ và tệp trước khi tải lên',
      reason: 'Lý do (ghi vào nhật ký)',
      dialogTitle: 'Tải lên: {{kind}}',
      badExtension: 'Loại hồ sơ này chỉ nhận tệp {{list}}.',
      tooLarge: 'Tệp quá lớn: tối đa {{max}} cho loại hồ sơ này.',
      tooSmall: 'VNNIC chỉ nhận tệp từ {{min}} trở lên cho loại hồ sơ này.',
      dialogBody: 'Tệp “{{file}}” được gắn vào hồ sơ; tệp PDF được kiểm tra chữ ký số tự động.',
      done: 'Đã tải lên.',
      declarationBody: 'Tệp “{{file}}” đi qua cùng quy trình như bản khai khách hàng nộp: PDF ký số được kiểm tra chữ ký, bản scan được đối chiếu rồi nhân viên duyệt, sau đó NĐK ký.',
      individualDeclarationTitle: 'Cá nhân vẫn cần eKYC',
      individualDeclaration: 'Cá nhân vẫn cần eKYC; bản khai tải lên chỉ lưu vào hồ sơ. Bản khai này không thay cho eKYC và không xác minh chủ thể.',
      declarationDone: 'Bản khai đã vào quy trình kiểm tra: chữ ký số / đối chiếu bản giấy, rồi nhân viên duyệt và NĐK ký.',
      downloaded: 'Đã tải bản khai.',
    },
    checklist: {
      title: 'Kiểm tra nhanh',
      declared: 'Có bản khai tên miền',
      accepted: 'Bản khai được chấp nhận',
      verified: 'Chủ thể đã xác minh',
      subject: 'Hồ sơ đúng chủ thể hiện tại',
      files: 'Đủ tệp VNNIC yêu cầu',
      registrar: 'NĐK đã ký bản khai',
      required: 'Bắt buộc: {{name}}',
      requiredEkyc: 'Bắt buộc: {{name}} (đủ qua eKYC)',
      vnnic: { APPROVED: 'VNNIC đã duyệt', PENDING: 'Đã gửi VNNIC, chờ duyệt', REJECTED: 'VNNIC từ chối', NOT_SENT: 'Chưa gửi VNNIC' },
      vnnicUnknown: 'Gửi VNNIC',
      state: { ok: 'Đạt', waiting: 'Đang chờ', missing: 'Chưa đạt', unknown: 'Chưa biết' },
    },
    files: {
      title: 'Hồ sơ đã tải lên',
      kind: 'Loại hồ sơ',
      status: 'Trạng thái',
      vnnic: 'Gửi VNNIC',
      dates: 'Tạo / cập nhật',
      file: 'Tệp',
      actions: 'Thao tác',
      sent: 'Đã gửi',
      notSent: 'Chưa gửi',
      view: 'Xem',
      download: 'Tải về',
      details: 'Chi tiết giấy tờ',
      readTitle: 'Mở tệp {{name}}',
      readBody: 'Tệp hồ sơ chứa dữ liệu định danh: lần mở được ghi nhật ký kèm lý do và cần quyền xem giấy tờ định danh.',
      previewHint: 'Bản lưu trên hệ thống, được giải mã để xem.',
      registrarSigned: 'NĐK đã ký',
      reason: 'Lý do: {{reason}}',
      created: 'Tạo {{date}}',
      updated: 'Cập nhật {{date}}',
      none: 'Chưa có tệp nào trong hồ sơ',
      older: 'Bản cũ ({{count}}): đã có bản mới hơn cùng loại, chỉ còn trong lịch sử',
      failed: 'Không tải được danh sách tệp',
      approve: 'Duyệt',
      reject: 'Từ chối',
      replace: 'Thay thế',
      requestMore: 'Yêu cầu bổ sung',
      noReview: 'Không có việc cần duyệt cho hồ sơ này',
      notPending: 'Tệp này không chờ duyệt',
      notReplaceable: 'Loại tệp này không có trong danh sách tải lên của hồ sơ',
      noRequest: 'Hồ sơ không nằm trong danh sách chờ hồ sơ: không có gì để yêu cầu bổ sung',
    },
    state: { APPROVED: 'Đã duyệt', PENDING: 'Chờ duyệt', REJECTED: 'Từ chối' },
    reason: {
      EKYC_AUTO: 'Xác nhận tự động eKYC',
      SIGNATURE_AUTO: 'Xác nhận tự động (chữ ký số hợp lệ)',
      STAFF_APPROVED: 'Nhân viên đã duyệt',
      AUTO_CHECK: 'Kiểm tra tự động đạt',
      ORG_DECLARATION: 'Tạo từ chủ thể, duyệt theo bản khai tổ chức đã ký (#27)',
      AWAITING_REGISTRAR: 'Chờ NĐK ký',
      AWAITING_STAFF: 'Chờ nhân viên duyệt',
      GENERATED: 'Bản mẫu do hệ thống tạo, chưa phải bản khách đã ký và nộp',
      STORED: 'Đã lưu vào hồ sơ; chưa có yêu cầu duyệt cho tệp này',
      AWAITING_IDENTITY: 'Cần kết quả eKYC của cá nhân trước khi hoàn tất hồ sơ',
      AWAITING_CHECK: 'Hệ thống đang kiểm tra tệp đã nộp',
      FORMAT: 'Định dạng tệp không đúng quy định VNNIC',
      SIZE: 'Dung lượng tệp không đúng quy định VNNIC',
      DIMENSIONS: 'Kích thước ảnh không đúng quy định VNNIC',
      CHECK_FAILED: 'Kiểm tra tự động không đạt',
      OTHER: 'Tệp không dùng được cho hồ sơ VNNIC',
    },
    fileType: { 1: 'CCCD mặt trước', 2: 'CCCD mặt sau', 3: 'Hộ chiếu', 4: 'Giấy phép ĐKKD', 5: 'Bản khai tên miền', 6: 'Cam kết tên miền gov.vn', 7: 'Cam kết từ khoá nhạy cảm', 15: 'Bản khai chuyển đổi NĐK', 16: 'Bản khai thông tin tổ chức' },
    sign: {
      button: 'Ký SmartCA',
      title: 'NĐK ký: {{kind}}',
      body: 'NĐK ký số tệp bằng SmartCA. “Gửi ký ngay” gửi yêu cầu xác nhận lên ứng dụng SmartCA bây giờ; “Vào lô {{time}}” ký cùng các hồ sơ khác trong lô hằng ngày.',
      now: 'Gửi ký ngay',
      batch: 'Vào lô {{time}}',
      queued: 'Chờ lô ký {{time}}',
      inBatch: 'Đang chờ ký trên app',
      signed: 'Đã ký',
      expired: 'Hết hạn — gửi lại',
      checking: 'Đang kiểm tra trước khi ký',
      review: 'Cần sửa hồ sơ trước khi ký',
      unavailable: 'Chỉ gửi ký được tệp PDF chưa có chữ ký NĐK',
      alreadyQueued: 'Tệp đã nằm trong lô ký {{time}}.',
      sent: 'Đã gửi ký. Xác nhận trên ứng dụng SmartCA.',
      failed: 'Không gửi được yêu cầu ký. Tải lại trang rồi thử lại.',
      queuedDone: 'Đã vào lô ký {{time}}.',
      acceptedWhenSigning: 'Bản khai đã được duyệt khi ký (NĐK duyệt khi ký).',
    },
    ekyc: {
      title: 'Kết quả eKYC',
      score: 'Kết quả eKYC (độ khớp khuôn mặt)',
      requestId: 'Mã yêu cầu eKYC',
      verifiedAt: 'Xác thực lúc',
      provider: 'Nhà cung cấp',
      result: 'Kết quả',
      none: 'Chưa có kết quả eKYC. Khách hàng làm eKYC trên cổng khách hàng; nhân viên chưa làm eKYC thay khách được trên trang này.',
      org: 'Tổ chức xác thực bằng chữ ký số, không dùng eKYC.',
    },
    identity: {
      title: 'Thông tin chủ thể (đã che)',
      name: 'Họ tên / tên tổ chức',
      ids: 'Giấy tờ',
      birth: 'Ngày sinh',
      birthOnFile: 'Đã lưu (không hiển thị)',
      nationality: 'Quốc tịch',
      address: 'Địa chỉ',
      signer: 'Người ký bản khai',
      masked: 'Số giấy tờ được che; số đầy đủ chỉ xem được ở trang chủ thể (có ghi nhật ký).',
      openSubject: 'Mở trang chủ thể',
      failed: 'Không tải được thông tin chủ thể',
      none: 'Hồ sơ chưa gắn chủ thể.',
    },
    vnnic: {
      title: 'Hồ sơ trên VNNIC',
      notReady: 'hồ sơ chưa hoàn tất; xử lý các bước ở trên trước khi gửi',
      sync: 'Đồng bộ',
      syncHint: 'Cập nhật trạng thái hồ sơ trên VNNIC',
      type: 'Loại',
      id: 'ID hồ sơ VNNIC',
      createdBy: 'Tạo bởi',
      createdAt: 'Ngày tạo',
      updatedBy: 'Cập nhật bởi',
      updatedAt: 'Ngày cập nhật',
      method: 'Hình thức xác thực',
      methodValue: '#{{n}} {{name}}',
      ekycScore: 'Kết quả eKYC',
      ekycRequest: 'Mã yêu cầu eKYC',
      signer: 'Người ký',
      signedAt: 'Ngày ký',
      status: 'Trạng thái hồ sơ',
      statusValue: { APPROVED: 'Đã duyệt', PENDING: 'Chờ duyệt', REJECTED: 'Từ chối', NOT_SENT: 'Chưa gửi' },
      notSent: 'Chưa gửi VNNIC',
      resend: 'Cần bổ sung trước khi gửi lại',
      missing: 'còn thiếu: {{list}}',
      ready: 'đủ điều kiện, hệ thống gửi tự động',
      fileId: 'ID',
      fileName: 'Tên tệp',
      fileSize: 'Dung lượng',
      fileType: 'Loại',
      fileSign: 'Ký',
      fileView: 'Xem nhanh tệp',
      fileDownload: 'Tải tệp',
      fileUnavailable: 'VNNIC chưa trả tệp, thử lại sau',
      filePreviewHint: 'Tệp lấy từ hồ sơ trên VNNIC (hoặc bản trên hệ thống khi chưa gửi).',
      fileReadTitle: 'Mở tệp {{name}}',
      fileReadBody: 'Tệp hồ sơ chứa dữ liệu định danh: lần mở được ghi nhật ký kèm lý do và cần quyền xem giấy tờ định danh.',
      fileCreated: 'Ngày tạo',
      signedBy: { 0: 'Không ký', 1: 'Chủ thể ký', 2: 'Ký bởi NĐK' },
      failed: 'Không tải được trạng thái VNNIC',
      notVn: 'Tên miền không thuộc .vn: hồ sơ không gửi VNNIC.',
      registrar: 'Nhà đăng ký',
    },
    blocker: {
      signed1: '{{name}} (chủ thể ký số)',
      signed2: '{{name}} (NĐK ký)',
      or: ' hoặc ',
      rejected: '{{name}}: {{problem}}',
      NO_DOC_TYPE: 'nghiệp vụ này chưa có loại hồ sơ VNNIC',
      NO_VERIFICATION: 'chủ thể chưa được xác thực',
      METHOD_NOT_ACCEPTED: 'hình thức xác thực chủ thể không được VNNIC chấp nhận',
      CASE_UNSUPPORTED: 'trường hợp của tên miền không áp dụng được với hình thức xác thực này',
      NO_CASE: 'chưa có quy định hồ sơ VNNIC cho nghiệp vụ và hình thức xác thực này',
      EKYC_REQUEST_ID: 'thiếu mã yêu cầu eKYC',
      EKYC_SCORE: 'thiếu kết quả eKYC (độ khớp khuôn mặt)',
      SIGNER_UNKNOWN: 'chưa rõ người ký và ngày ký của tệp ký số',
      OTHER: 'hồ sơ cần nhân viên kiểm tra lại',
    },
    versions: {
      title: 'Lịch sử hồ sơ',
      failed: 'Không tải được lịch sử hồ sơ',
      created: 'tạo {{date}}',
      completed: 'hoàn tất {{date}}',
      current: 'Hiện tại',
    },
  },
  overview: {
    expiry: 'Ngày hết hạn',
    daysLeft_one: 'Còn {{count}} ngày',
    daysLeft_other: 'Còn {{count}} ngày',
    expired_one: 'Đã hết hạn {{count}} ngày',
    expired_other: 'Đã hết hạn {{count}} ngày',
    renewPrice: 'Gia hạn 1 năm',
    renewPriceHint: 'Bảng giá mặc định, chưa gồm thuế',
    noPrice: 'Bảng giá mặc định chưa có giá gia hạn',
    dossier: 'Tệp hồ sơ',
    filesComplete: 'Đủ mọi tệp bắt buộc',
    filesMissing_one: 'Thiếu {{count}} tệp',
    filesMissing_other: 'Thiếu {{count}} tệp',
    versionN: 'phiên bản {{n}}',
    registration: 'Thông tin đăng ký',
    registrationHint: 'Bản ghi của hệ thống và thông tin registry trả về, đặt cạnh nhau.',
    ascii: 'Tên miền ASCII',
    unicode: 'Tên miền Unicode',
    domainId: 'Mã tên miền',
    roid: 'Mã tại registry',
    notRead: 'Chưa đọc từ registry',
    createdAt: 'Ngày tạo bản ghi',
    registryCreated: 'Ngày tạo tại registry',
    registryExpiry: 'Hết hạn tại registry',
    paidThrough: 'Khách đã trả đến',
    tld: 'TLD / nhóm',
    registry: 'Registry',
    sponsor: 'Nhà đăng ký tài trợ tại registry',
    lifecycle: 'Trạng thái',
    snapshot: 'Đọc từ registry lần cuối',
    record: 'Bản ghi',
    recordValue: 'phiên bản {{version}} · {{at}}',
    subjectDossier: 'Chủ thể & hồ sơ',
    subjectVersion: 'Phiên bản chủ thể trong hồ sơ',
    dossierLine: 'Bộ hồ sơ',
    verification: 'Xác minh',
    completed: 'Hồ sơ hoàn tất',
    openSubject: 'Xem chủ thể',
    openDossier: 'Xem hồ sơ',
    dnsSecurity: 'DNS & bảo mật',
    manage: 'Quản lý',
    nameservers: 'Máy chủ tên',
    none: 'Chưa có',
    dnssec: 'DNSSEC',
    dnssecOn_one: 'Đã bật · {{count}} bản ghi DS',
    dnssecOn_other: 'Đã bật · {{count}} bản ghi DS',
    dnssecOff: 'Chưa bật',
    transferLock: 'Khoá chuyển',
    autoRenew: 'Tự động gia hạn',
    on: 'Bật',
    off: 'Tắt',
    related: 'Công việc & giao dịch liên quan',
    relatedHint: 'Đơn hàng, hoá đơn và việc đang mở của {{domain}}.',
    relatedKind: 'Đối tượng',
    relatedRef: 'Mã tham chiếu',
    relatedState: 'Trạng thái',
    openRow: 'Mở',
    order_one: 'Đơn hàng · {{operation}} {{count}} năm',
    order_other: 'Đơn hàng · {{operation}} {{count}} năm',
    invoice: 'Hoá đơn',
    creditNote: 'Hoá đơn điều chỉnh',
    workOpen: 'Đang mở',
    loading: 'Đang tải…',
    noRelated: 'Tên miền này chưa có đơn hàng, hoá đơn hay việc đang mở',
  },
  dns: {
    title: 'Máy chủ tên tại registry',
    hint: 'Uỷ quyền DNS tại registry: cấu hình của hệ thống đặt cạnh những gì registry trả về ở lần kiểm tra gần nhất.',
    change: 'Đổi máy chủ tên',
    driftTitle: 'Registry đang giữ máy chủ tên khác',
    driftAddressesTitle: 'Registry đang giữ địa chỉ IP máy chủ tên khác',
    driftBody: 'Phát hiện ở lần kiểm tra {{at}}. Đang đối soát: hỏi lại khách trước khi thay đổi.',
    ours: 'Cấu hình của hệ thống',
    ipv4: 'IPv4: {{list}}',
    ipv6: 'IPv6: {{list}}',
    addressesDiffer: 'Khác địa chỉ IP',
    atRegistry: 'Tại registry',
    notRead: 'Chưa đọc',
    match: 'Đối chiếu',
    unknown: 'Chưa đối chiếu',
    same: 'Khớp',
    missingAtRegistry: 'Registry không có',
    onlyAtRegistry: 'Chỉ có tại registry',
    delegation: 'Uỷ quyền',
    state: 'Trạng thái DNS',
    hostObjects: 'Registry lưu đối tượng máy chủ tên',
    yes: 'Có',
    no: 'Không',
    snapshot: 'Đọc từ registry lần cuối',
    registry: 'Registry',
    zoneTitle: 'Bản ghi DNS không quản lý tại đây',
    zoneBody: 'Tên miền trỏ tới các máy chủ tên ở trên; bản ghi (A, MX, TXT…) do các máy chủ đó quản lý.',
  },
  fees: {
    title: 'Bảng tính phí theo nghiệp vụ',
    hint: 'Tính từ giá của TLD này (bảng giá mặc định); không tạo đơn hàng, không trừ ví.',
    operation: 'Nghiệp vụ',
    years: 'Kỳ hạn',
    yearsN_one: '{{count}} năm',
    yearsN_other: '{{count}} năm',
    failed: 'Không tính được phí',
    none: 'TLD này chưa có giá',
  },
  finance: {
    invoiced: 'Đã lập hoá đơn',
    invoices_one: '{{count}} hoá đơn',
    invoices_other: '{{count}} hoá đơn',
    held: 'Đang giữ',
    heldHint: 'Tiền giữ cho thao tác đang chạy',
    refunded: 'Đã hoàn',
    refunds_one: '{{count}} lần hoàn',
    refunds_other: '{{count}} lần hoàn',
    priceTitle: 'Giá bán, giá mua & kỳ gia hạn tới',
    priceHint: 'Một năm gia hạn theo bảng giá mặc định, đặt cạnh chi phí registry.',
    sell: 'Giá bán (chưa thuế)',
    cost: 'Chi phí registry',
    margin: 'Chênh lệch',
    total: 'Khách trả (gồm thuế)',
    autoRenew: 'Tự động gia hạn',
    autoRenewOn_one: 'Bật · {{count}} năm',
    autoRenewOn_other: 'Bật · {{count}} năm',
    off: 'Tắt',
    paidThrough: 'Khách đã trả đến',
    noPrice: 'Bảng giá mặc định chưa có giá gia hạn.',
    note: 'Đã thanh toán không có nghĩa thao tác tại registry đã thành công: trạng thái registry ở tab Registry.',
  },
  renewal: {
    title: 'Tự động gia hạn & nhắc hạn',
    hint: 'Bật tự động gia hạn không trừ tiền và không gia hạn ngay; nhắc hạn theo quy định thông báo hết hạn.',
    renew: 'Gia hạn',
    autoRenew: 'Tự động gia hạn',
    on_one: 'Bật · {{count}} năm',
    on_other: 'Bật · {{count}} năm',
    off: 'Tắt',
    registryExpiry: 'Hết hạn tại registry',
    paidThrough: 'Khách đã trả đến',
    lastNotice: 'Lần nhắc gần nhất',
    noNotice: 'Chưa gửi',
    failed: 'Không tải được các lần nhắc',
    note: 'Ngày ân hạn và chuộc lại tuỳ quy định của từng TLD; trang này không tự suy ra từ ngày hết hạn.',
  },
  security: {
    title: 'Khoá & điều kiện chuyển',
    hint: 'Mã chuyển không bao giờ hiển thị ở đây; cấp mã là thao tác riêng và được ghi nhật ký.',
    lock: 'Khoá chuyển',
    unlock: 'Mở khoá chuyển',
    code: 'Mã chuyển',
    transferLock: 'Khoá chuyển',
    on: 'Bật',
    off: 'Tắt',
    ourLocks: 'Khoá của nhà đăng ký',
    until: 'đến {{date}}',
    none: 'Không có',
    codeSet: 'Đã cấp {{date}}',
    noCode: 'Chưa cấp',
    legal: 'Khoá pháp lý',
    transfer: 'Chuyển nhà đăng ký',
    registrant: 'Đổi chủ thể',
    changeRegistrant: 'Đổi chủ thể',
    noteTitle: 'Chuyển nhà đăng ký không đổi chủ thể',
    note: 'Chuyển sang nhà đăng ký khác và đổi chủ thể là hai nghiệp vụ riêng, mỗi nghiệp vụ có bước kiểm tra riêng.',
  },
  registryState: {
    title: 'Registry & nhà đăng ký tài trợ',
    hint: 'Registry trả về gì ở lần kiểm tra gần nhất.',
    registry: 'Registry',
    sponsor: 'Nhà đăng ký tài trợ',
    roid: 'Mã tại registry',
    read: 'Đọc lúc',
    notRead: 'Chưa đọc',
    created: 'Ngày tạo tại registry',
    connection: 'Kết nối',
    diffTitle: 'Chênh lệch nội bộ ↔ registry',
    diffHint: 'Không bên nào tự ghi đè bên kia cho đến khi chênh lệch được kiểm tra.',
    field: 'Thuộc tính',
    ours: 'Của hệ thống',
    theirs: 'Tại registry',
    result: 'Kết quả',
    match: { same: 'Khớp', differs: 'Khác', unknown: 'Chưa đối chiếu' },
    expiry: 'Ngày hết hạn',
    statuses: 'Trạng thái',
    nameservers: 'Máy chủ tên',
    glue: 'Địa chỉ IP máy chủ tên (glue)',
    issuesHidden: 'Vai trò của bạn không xem được kết quả đối soát.',
    noIssues: 'Đối soát không thấy chênh lệch nào của tên miền này.',
    detected: 'phát hiện {{date}}',
    openIssue: 'Mở',
    issueTypes: { NAMESERVER: 'Máy chủ tên khác nhau', EXISTENCE: 'Tên miền thiếu hoặc thừa tại registry', SPONSORSHIP: 'Nhà đăng ký khác đang tài trợ', UNKNOWN_OUTCOME: 'Lệnh chưa rõ kết quả' },
    issueStates: { OPEN: 'Đang mở', AUTO_RECONCILING: 'Đang tự đối soát', MANUAL_REVIEW: 'Cần nhân viên', RESOLVED: 'Đã xử lý', IGNORED: 'Đã bỏ qua' },
    sync: {
      button: 'Đồng bộ với registry',
      busy: 'Đang đọc registry…',
      done: 'Đã đồng bộ lúc {{time}}.',
      IN_SYNC: 'Khớp với registry.',
      REFRESHED: 'Đã cập nhật bản sao thông tin registry của hệ thống: {{fields}}.',
      ISSUES_OPENED: 'Có chênh lệch cần kiểm tra: {{fields}} (xem bên dưới). Không bên nào bị ghi đè.',
    },
  },
  syncCompare: {
    title: 'Đối chiếu phiên bản trước đồng bộ',
    hint: 'Lần đồng bộ gửi hồ sơ cùng phiên bản chủ thể mà hồ sơ giữ; không tự đánh dấu đã được tiếp nhận.',
    subject: 'Phiên bản chủ thể',
    subjectValue: 'hồ sơ v{{pinned}} · chủ thể hiện là v{{current}}',
    behind: 'chủ thể đã đổi sau đó',
    dossier: 'Hồ sơ',
    sent: 'Đã gửi VNNIC',
    notSent: 'Chưa gửi',
    notSentYet: 'phiên bản hiện tại chưa được gửi',
    state: 'Trạng thái đồng bộ',
    compliance: 'Tuân thủ',
    complianceStates: { UNKNOWN: 'Chưa đánh giá', COMPLIANT: 'Tuân thủ', ACTION_REQUIRED: 'Cần xử lý', BLOCKED: 'Bị chặn', SUSPENDED: 'Tạm ngừng' },
    note: 'Gửi lại hoặc báo cáo thực hiện ở các trang VNNIC bên dưới.',
  },
  notes: {
    title: 'Ghi chú nội bộ',
    hint: 'Ghi chú của nhân viên trên hồ sơ của tên miền này; không gửi cho khách.',
    add: 'Thêm ghi chú',
    none: 'Chưa có ghi chú.',
    notQueued: 'Ghi chú được lưu trên hồ sơ trong hàng đợi thẩm định; hồ sơ này không nằm ở đó.',
  },
  subjectPage: {
    verified: 'Đã xác minh',
    notVerified: 'Chưa xác minh',
    needsEkyc: 'Chưa xác minh (cần eKYC)',
    needsEkycNote: 'Cá nhân chỉ được xác minh bằng eKYC: bản khai ký số không còn được chấp nhận cho thao tác mới. Tên miền đã đăng ký giữ nguyên hồ sơ.',
    domains_one: '{{count}} tên miền',
    domains_other: '{{count}} tên miền',
    version: 'Phiên bản {{n}}',
    verification: 'Xác minh danh tính',
    noVerification: 'Phiên bản hiện tại chưa được xác minh (eKYC hoặc tài liệu ký số).',
    versionsHint: 'Phiên bản trước được giữ; mỗi tên miền giữ phiên bản đã sao chép.',
    controlledTitle: 'Cập nhật có kiểm soát',
    controlledBody: 'Sửa chủ thể tạo phiên bản mới; tên miền giữ liên hệ riêng cho đến khi nhân viên chọn đồng bộ (xem “Tên miền dùng chủ thể này”).',
  },
  record: {
    title: 'Bản ghi & ngữ cảnh',
    version: 'Phiên bản bản ghi',
    updated: 'Cập nhật',
    unresolved: 'Lệnh chưa rõ kết quả',
    history: 'Xem lịch sử',
  },
};
